import ApiService from '../services/ApiService';
import { goToErrorPage, goToNextStep } from './GenericActions';
import * as types from './ActionTypes';

const requestSendingLetter = postalCode => ({
  type: types.REQUEST_SENDING_LETTER,
  payload: {
    postalCode,
  },
});

const sendLetterSuccess = () => ({
  type: types.SEND_LETTER_SUCCESS,
});

const sendLetterFailure = err => ({
  type: types.SEND_LETTER_FAILURE,
  err,
});

export const setPostalCodeError = errorType => ({
  type: types.SET_POSTAL_CODE_ERROR,
  payload: {
    errorType,
  },
});

export const clearPostalCodeError = error => ({
  type: types.CLEAR_POSTAL_CODE_ERROR,
  error,
});

/**
 * Function to check if a letter is already pending
 * @return {Function}
 */
export const checkPendingLetter = () => async (dispatch) => {
  try {
    const response = await ApiService.checkPendingLetter();

    if (response && response.data && response.data.data && response.data.data.letter) {
      dispatch(goToErrorPage('letterIsPending'));
    } else {
      dispatch(goToNextStep('letter'));
    }
  } catch (err) {
    if (err.response && err.response.status) {
      switch (err.response.status) {
        case 403:
          dispatch(goToErrorPage('letterAttemptsExceeded'));
          break;
        default:
          dispatch(goToErrorPage());
      }
    }
  }
};

/**
 * Function to send a letter with temporary password
 * @param postalCode
 * @return {Function}
 */
export const sendLetter = postalCode => async (dispatch) => {
  try {
    dispatch(requestSendingLetter(postalCode));
    const response = await ApiService.sendLetter({ postalCode });

    if (response && response.status) {
      switch (response.status) {
        case 200:
          dispatch(sendLetterSuccess());
          break;
        default:
          dispatch(goToErrorPage());
      }
    }
  } catch (err) {
    dispatch(sendLetterFailure(err));
    if (err.response && err.response.data && err.response.data.code) {
      switch (err.response.data.code) {
        case 403201:
          dispatch(goToErrorPage('letterIsPending'));
          break;
        case 412002:
          dispatch(setPostalCodeError('empty'));
          break;
        case 412201:
          dispatch(setPostalCodeError('incorrect'));
          break;
        case 403202:
          dispatch(goToErrorPage('letterAttemptsExceeded'));
          break;
        default:
          dispatch(goToErrorPage());
      }
    }
  }
};
